import { render, staticRenderFns } from "./ClaimHistoryDate.vue?vue&type=template&id=e7f2ff9c&"
import script from "./ClaimHistoryDate.vue?vue&type=script&lang=js&"
export * from "./ClaimHistoryDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports